import { LocalStorageItemKeys } from '@/types';

export const setLocalStorage = (key: LocalStorageItemKeys, value: string): void => {
  localStorage.setItem(key, value);
};

export const getLocalStorage = (key: LocalStorageItemKeys): string => {
  return localStorage.getItem(key) ?? '';
};

export const clearLocalStorage = (): void => {
  localStorage.clear();
};
